import React from 'react'
import BaseIcon from 'react-icon-base'

const MicroActivities: React.FC<any> = () => (
  <BaseIcon width="14" height="25" viewBox="0 0 22 25">
    <g fill="none" fillRule="evenodd">
      <g fill="#9FB7C1" fillRule="nonzero">
        <g>
          <path
            d="M12.203 24V0H9.797v24h2.406zm4.928-4.788V4.788h-2.464v14.424h2.464zm-9.798 0V4.788H4.87v14.424h2.464zM22 14.423V9.577h-2.464v4.846H22zm-19.536 0V9.577H0v4.846h2.464z"
            transform="translate(-45.000000, -480.000000) translate(45.000000, 480.700000)"
          />
        </g>
      </g>
    </g>
  </BaseIcon>
)

export default MicroActivities
